import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Welcome to Smart Status and ICAD reporting. ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Navigate to the application you wish to view ")
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  style: {"text-align":"center"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isAuthenticated)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _hoisted_6))
      : (_openBlock(), _createElementBlock("h1", _hoisted_7, " Welcome to Smart Status and ICAD reporting. Please sign in to continue. "))
  ]))
}